import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button, Form, Input, Modal } from "antd";

import { ValidationForm } from "../../common/interfaces";
import { commonUtil } from "../../utils";

interface Props {
  titleText: string;
  confirmText: string;
  onClose?: (data?: any) => void;
  onSubmit?: (password: string) => Promise<void>;
}

const SetPassword: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation(["common", "notification"]);
  const [newPass, setNewPass] = useState<string>("");
  const [confirmPass, setConfirmPass] = useState<string>("");
  const [validateNewPass, setValidateNewPass] = useState<ValidationForm | null>(
    null
  );
  const [validateConfirmPass, setValidateConfirmPass] =
    useState<ValidationForm | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  // handle change new password
  const onChangeNewPass = (value: string) => {
    setNewPass(value.trim());
    setValidateNewPass(null);
  };

  // handle change confirm password
  const onChangeConfirmPass = (value: string) => {
    setConfirmPass(value.trim());
    setValidateConfirmPass(null);
  };

  // dùng chung cho 2 trường hợp:
  const handleSubmit = async () => {
    if (!newPass || newPass.trim() === "") {
      setValidateNewPass({
        status: "error",
        text: t("notification:Vui lòng nhập mật khẩu mới"),
      });
      return;
    }
    if (newPass && !commonUtil.isPasswordValid(newPass)) {
      setValidateNewPass({
        status: "error",
        text: t("notification:Mật khẩu không đúng định dạng"),
      });
      return false;
    }
    if (newPass.length < 8) {
      setValidateNewPass({
        status: "error",
        text: t("notification:Mật khẩu phải có ít nhất 8 ký tự"),
      });
      return;
    }
    if (!confirmPass || confirmPass.trim() === "") {
      setValidateConfirmPass({
        status: "error",
        text: t("notification:Vui lòng nhập lại mật khẩu mới"),
      });
      return;
    }
    if (confirmPass !== newPass) {
      setValidateConfirmPass({
        status: "error",
        text: t("notification:Mật khẩu không khớp"),
      });
      return;
    }
    if (props.onSubmit) {
      setLoading(true);
      await props.onSubmit(newPass);
      setLoading(false);
    }
  };

  return (
    <Modal
      footer={null}
      visible={true}
      maskClosable={false}
      title={props.titleText}
      onCancel={props.onClose}
    >
      <div>
        <Form size={"large"}>
          <Form.Item
            validateStatus={validateNewPass?.status}
            help={validateNewPass?.text}
          >
            <Input.Password
              placeholder={t("common:Mật khẩu mới")}
              value={newPass}
              onChange={(event) => onChangeNewPass(event.target.value)}
            />
          </Form.Item>
          <Form.Item
            validateStatus={validateConfirmPass?.status}
            help={validateConfirmPass?.text}
          >
            <Input.Password
              placeholder={t("common:Nhập lại mật khẩu mới")}
              value={confirmPass}
              onChange={(event) => onChangeConfirmPass(event.target.value)}
            />
          </Form.Item>

          <Button
            type="primary"
            block={true}
            style={{
              textTransform: "uppercase",
              fontWeight: "bold",
            }}
            onClick={handleSubmit}
            loading={loading}
          >
            {props.confirmText}
          </Button>
        </Form>
      </div>
    </Modal>
  );
};

export default SetPassword;
